import { KeyboardService } from '@shared/services/keyboard.service';
import { KeyName, normalizeKeys } from '@local/ts-infra';
import { firstValueFrom } from 'rxjs';
import { ShortcutHandler } from '../view-item/view-item.component';
import { Commands, Search } from '@local/client-contracts';
import { EventInfo } from '@shared/services';
import { TelemetryTrigger } from '../../results/models/results-types';
import { PeopleViewItemComponent } from './people-view-item/people-view-item.component';
import { ResourceViewItemComponent } from '../view-item/resource-view-item.component';

export class PeopleViewItemService {
  static async setShortcutsHandlers(
    keyboardService: KeyboardService,
    shortcutsHandlers: ShortcutHandler[],
    resourceViewItem: ResourceViewItemComponent,
    model: Search.ResultResourceItem
  ) {
    const copyEmail = await firstValueFrom(keyboardService.get('_people_copyEmail'));
    const copyPhone = await firstValueFrom(keyboardService.get('_people_copyPhone'));
    let keys: string[];

    if (copyEmail) {
      keys = normalizeKeys(<string[]>copyEmail.keys).map((k) => k.toLowerCase());
      if (keys) {
        shortcutsHandlers.push(this.createNewItem(keys, 'email', model, resourceViewItem));
      }
    }

    if (copyPhone) {
      keys = normalizeKeys(<string[]>copyPhone.keys).map((k) => k.toLowerCase());
      if (keys) {
        shortcutsHandlers.push(this.createNewItem(keys, 'phone', model, resourceViewItem));
      }
    }
  }

  static createNewItem(keys, trait, model: Search.ResultResourceItem, thiss: ResourceViewItemComponent) {
    return {
      fn: (item: PeopleViewItemComponent, trigger: TelemetryTrigger, eventInfo) => {
        this.copyBullet(model, trigger, eventInfo, trait, thiss);
      },
      keyBinding: keys as KeyName[],
    };
  }

  static copyBullet(
    model: Search.ResultResourceItem,
    trigger: TelemetryTrigger,
    eventInfo: Partial<EventInfo>,
    traitName: string,
    thiss: ResourceViewItemComponent
  ): boolean {
    const isTextSelected = document.getSelection() && document.getSelection().toString() !== '';
    const trait = model.resource.traits[traitName];
    if (!isTextSelected && trait) {
      const command: Commands.CopyClipboard = { type: 'copy-clipboard', value: trait };
      if (traitName === 'phone' && trait.number) {
        command.value = trait.code ? `+${trait.code}-${trait.number}` : trait.number;
      }
      thiss.onInvoke({ command, trigger, eventInfo });
      return true;
    }
    return false;
  }
}
